module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"chapters":"Chapters"},"fr":{"chapters":"Chapitres"}}')
  delete Component.options._Ctor
}
